import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table, Pagination, Modal } from "antd";
import Filter from "../../../components/filter/Filter";
import { useDispatch } from "react-redux";
import { deleteRegion, getRegions } from "../../../redux/slices/regions/regionsThunk";
import { useSelector } from "react-redux";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { toast } from "react-toastify";
import { columns } from "./columns";

const RegionPage = () => {
  const [filter, setFilter] = useState({
    government: []
  });

  const [ids, setIds] = useState({
    government: []
  });

  const [search, setSearch] = useState({
    government: "",
    searchTerm: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const dispatch = useDispatch();

  const governmentsData = useSelector((state) => state.governments.governments);
  const government_loading = useSelector((state) => state.governments.loading);
  const regions_data = useSelector((state) => state.regions.regions);
  const region_loading = useSelector((state) => state.regions.loading);
  const totalItems = useSelector((state) => state.regions.regions?.total);


  useEffect(() => {
    dispatch(getRegions({
      page: pagination.currentPage,
      itemsPerPage: pagination.pageSize,
      governmentId: ids.government,
      search: search.searchTerm
    }));
  }, [dispatch, filter, pagination, ids, search.searchTerm]);

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 50, search: search.government }));
  }, [search.government, dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);

  const showModal = (id) => {
    setIsModalOpen(true);
    setCitemId(id);
  };

  const handlePagination = (page) => {
    setPagination(prev => ({ ...prev, currentPage: page }));
  };

  const history = useHistory();

  const naviagteTo = (path) => {
    history.push(path);
  };

  const handelDelete = (id) => {
    dispatch(deleteRegion(id)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Région supprimé avec succès");
        dispatch(getRegions({ page: pagination.pageSize, itemsPerPage: 10, filter }))
      } else if (result.meta.requestStatus === "rejected") {
        toast.error("Erreur pendant la suppression du Région");
      }
    });
    setIsModalOpen(false);
  };

  const createOptions = (data, labelKey = "name", valueKey = "name", idKey = "id") => {
    return data?.map((item) => ({
      id: item[idKey],
      label: item[labelKey],
      value: item[valueKey],
    })) || [];
  };

  const optionsLists = [
    {
      name: "Gouvernorat",
      placeholder: "Gouvernorat",
      key: "government",
      multiple: true,
      isLoading: government_loading,
      options: createOptions(governmentsData?.data, "name", "name"),
    },
  ];

  const handleSelect = (value, key, id) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [key]: Array.isArray(value) ? value : [value], // Ensure array format for multiple selection
    }));
    setIds((prevId) => ({
      ...prevId,
      [key]: Array.isArray(id) ? id : [id], // Ensure array format for multiple selection
    }));
    setPagination((prevPagination) => ({
      ...prevPagination,
      currentPage: 1, // Reset page to 1 when filter changes
    }));
  };

  const handleSearchedValue = (value, key) => {
    if (search[key] !== value) {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: value,
      }));
      if (key === "searchTerm")
        setPagination((prevPagination) => ({
          ...prevPagination,
          currentPage: 1, // Reset page to 1 when filter changes
        }));
    }
  };
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des régions"
            extra={
              <React.Fragment>
                <Button
                  type="primary"
                  onClick={() => naviagteTo("/nouvelle/région")}
                >
                  <PlusOutlined />
                  Ajouter une région
                </Button>
              </React.Fragment>
            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                optionsLists={optionsLists}
                onSelect={handleSelect}
                onSearchValue={handleSearchedValue}
                data={filter}
              />
            }
          >
            <Table
              columns={columns(naviagteTo, showModal)}
              dataSource={regions_data?.data}
              className="ant-border-space"
              pagination={false}
              scroll={{ x: 240 }}
              rowKey={(record) => record.id}
              loading={region_loading}
            />
          </Card>
          <Pagination
            current={pagination.currentPage}
            total={totalItems}
            pageSize={pagination.pageSize}
            onChange={handlePagination}
          />
        </Col>
        <Modal
          title="Supprimer une région"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={[
            <Button key="back" onClick={() => setIsModalOpen(false)}>
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => handelDelete(itemId)}
            >
              Supprimer
            </Button>,
          ]}
        >
          <p>Êtes-vous sûr de vouloir supprimer cette région ? </p>
        </Modal>
      </Row>
    </div>
  );
};

export default RegionPage;
